import { Button, PrimaryButton, Spacer, colors } from 'app-v2/design-systems'
import { ResponsiveContainer, media } from 'app/assets/styles'
import { Breadcrumb } from 'app/common/breadcrumb'
import { Layout } from 'app/common/layout'
import { H2, Text } from 'app/common/typography'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

export const OneTrustCookieManagementScreen = () => {
    const intl = useIntl()
    const cookiesTitle = intl.formatMessage({
        id: 'cookies.management.title'
    })

    return (
        <>
            <Layout background="plain" border>
                <StyledContainer>
                    <HeadContainer>
                        <CookiesHead>
                            <Breadcrumb
                                breadcrumbArray={[
                                    {
                                        title: `\u00A0>\u00A0${cookiesTitle}`
                                    }
                                ]}
                            />
                            <StyledH2>{cookiesTitle}</StyledH2>
                        </CookiesHead>
                    </HeadContainer>
                    {window?.OptanonActiveGroups && (
                        <CookiesContainer>
                            <button
                                id="ot-sdk-btn"
                                className="ot-sdk-show-settings"
                                //$FlowFixMe
                                onClick={() => OneTrust.ToggleInfoDisplay()}>
                                {intl.formatMessage({
                                    id: 'cookies.management.button'
                                })}
                            </button>
                            <Spacer />
                        </CookiesContainer>
                    )}
                </StyledContainer>
            </Layout>
        </>
    )
}

const CookiesContainer = styled.div`
    margin-top: 30px;
    text-align: center;
`

const StyledContainer = styled(ResponsiveContainer)`
    margin-top: 90px;
    text-align: justify;
    ${media.medium`
        margin-top: 150px;
    `};
`

const HeadContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: flex-start;
    flex-direction: column;
    ${media.medium`
        justify-content: space-between;
        flex-direction: row;
        width: 100%;
        align-items: center;
    `};
`

const CookiesHead = styled.div``

const StyledH2 = styled(H2)`
    margin: 0;
`
